import "vanilla-cookieconsent";

export function initiateCookieConsent() {

    let cc = initCookieConsent();
    let cookieTemplate = document.querySelector('#cookie-consent-template');
    if (cookieTemplate) {
        cookieTemplate = JSON.parse(cookieTemplate.innerHTML.trim());
    } else {
        //set default values
        cookieTemplate = {
        consentModalDescription: 'Hi, this website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only after consent. <button type="button" data-cc="c-settings" class="cc-link">Let me choose</button>',
        consentModalTitle: 'We use cookies!',
        moreInformationDescription: `For any queries in relation to our policy on cookies and your choices, please <a class="cc-link" href="/contact-us">contact us</a>.`,
        moreInformationTitle:
            "More information",
        settingsModalDescription: 'We use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want.',
        settingsModalTitle: "Cookie usage 📢"
        };
    }
    
    cc.run({
        current_lang: 'en',
        autoclear_cookies: true,
        page_scripts: true,
        // revision: 0,
        gui_options: {
            consent_modal: {
                layout: 'cloud',
                position: 'middle center',
                transition: 'slide',
                swap_buttons: false
            },
            settings_modal: {
                layout: 'box',
                transition: 'slide'
            }
        },
        languages: {
            'en': {
                consent_modal: {
                    title: cookieTemplate.consentModalTitle,
                    description: cookieTemplate.consentModalDescription,
                    primary_btn: {
                        text: 'Accept all',
                        role: 'accept_all'
                    },
                    secondary_btn: {
                        text: 'Reject all',
                        role: 'accept_necessary'
                    }
                },
                settings_modal: {
                    title: 'Cookie preferences',
                    save_settings_btn: 'Save settings',
                    accept_all_btn: 'Accept all',
                    reject_all_btn: 'Reject all',
                    close_btn_label: 'Close',
                    cookie_table_headers: [
                        {col1: 'Name'},
                        {col2: 'Domain'},
                        {col3: 'Expiration'},
                        {col4: 'Description'}
                    ],
                    blocks: [
                        {
                            title: cookieTemplate.settingsModalTitle,
                            description: cookieTemplate.settingsModalDescription
                        }, {
                            title: 'Strictly necessary cookies',
                            description: 'These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly',
                            toggle: {
                                value: 'necessary',
                                enabled: true,
                                readonly: true
                            },
                            cookie_table: [
                                {
                                    col1: 'ARRAffinity',
                                    col2: '/',
                                    col3: 'ARRAffinity cookie is set by Azure app service, and allows the service to choose the right instance established by a user to deliver subsequent requests made by that user.',
                                    col4: 'session'
                                },
                                {
                                    col1: 'ARRAffinitySameSite',
                                    col2: '/',
                                    col3: 'This cookie is set by Windows Azure cloud, and is used for load balancing to make sure the visitor page requests are routed to the same server in any browsing session.',
                                    col4: 'session'
                                },
                                {
                                    col1: '.AspNetCore.Antiforgery.^',
                                    col2: '/',
                                    col3: 'No description.',
                                    col4: 'Helps prevent Cross-Site Request Forgery (CSRF) attacks.',
                                    is_regex: true
                                },
                                {
                                    col1: 'RequestVerificationToken',
                                    col2: '/',
                                    col3: 'No description.',
                                    col4: 'session'
                                },
                                {
                                    col1: 'current.usersessionGuid',
                                    col2: '/',
                                    col3: 'No description.',
                                    col4: '3 months'
                                },
                                {
                                    col1: 'CookieConsent',
                                    col2: '/',
                                    col3: 'Stores the user\'s cookie consent state for the current domain',
                                    col4: '1 year'
                                }
                            ]
                        }, {
                            title: 'Performance and Analytics cookies',
                            description: 'These cookies allow the website to remember the choices you have made in the past',
                            toggle: {
                                value: 'analytics',
                                enabled: false,
                                readonly: false
                            },
                            cookie_table: [
                                {
                                    col1: 'ai_user',
                                    col2: '/',
                                    col3: '1 year',
                                    col4: 'A unique user identifier cookie, set by Microsoft Application Insights software, that enables counting of the number of users accessing the application over time.',
                                },
                                {
                                    col1: 'ai_session',
                                    col2: '/',
                                    col3: '30 minutes',
                                    col4: 'This is a unique anonymous session identifier cookie set by Microsoft Application Insights software to gather statistical usage and telemetry data for apps built on the Azure cloud platform.',
                                },
                                {
                                    col1: 'AI_sentBuffer',
                                    col2: '/',
                                    col3: 'Session',
                                    col4: 'Used in context with the &quot;AI_buffer&quot; in order to limit the number of data-server-updates (Azure). This synergy also allows the website to detect any duplicate data-server-updates.',
                                },
                                {
                                    col1: 'AI_buffer',
                                    col2: '/',
                                    col3: 'Session',
                                    col4: 'Used in context with the &quot;AI_sentBuffer&quot; in order to limit the number of data-server-updates (Azure).  This synergy also allows the website to detect any duplicate data-server-updates.',
                                },
                                {
                                    col1: '_ga',
                                    col2: '.google.com',
                                    col3: '2 years',
                                    col4: 'Used to distinguish users.'
                                },
                                {
                                    col1: '_ga_^',
                                    col2: '.google.com',
                                    col3: '2 years',
                                    col4: 'Used to persist session state.',
                                    is_regex: true
                                },
                                {
                                    col1: '_gid',
                                    col2: '.google.com',
                                    col3: '24 hours',
                                    col4: 'Used to distinguish users.'
                                },
                                {
                                    col1: '_gat',
                                    col2: '.google.com',
                                    col3: '1 minute',
                                    col4: `Used to throttle request rate. If Google Analytics is deployed via
      Google Tag Manager, this cookie will be named <code translate="no" dir="ltr">_<wbr>dc_<wbr>gtm_<wbr>&lt;property-
      id&gt;</code>.`
                                },
                                {
                                    col1: '_gac_^',
                                    col2: '.google.com',
                                    col3: '90 days',
                                    col4: `Contains campaign related information for the user. If you have
      linked your Google Analytics and Google Ads accounts, Google Ads
      website conversion tags will read this cookie unless you opt-out.
      <a href="//support..google.com/google-ads/answer/7521212">Learn more</a>.`,
                                    is_regex: true
                                }
                            ]
                        }, {
                            title: 'Advertisement and Targeting cookies',
                            description: 'These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you',
                            toggle: {
                                value: 'targeting',
                                enabled: false,
                                readonly: false
                            }
                        },
                        {
                            title: cookieTemplate.moreInformationTitle,
                            description: cookieTemplate.moreInformationDescription,
                        }
                    ]
                }
            }

        }
    });
}